module.exports = __webpack_public_path__ + "img/Average order value Icon - white.46a6eb14.svg";